// extracted by mini-css-extract-plugin
export default {"container":"Header_container__1KW92","heading":"Header_heading__qfJ6i","right":"Header_right__cLslc"};